/**
 * Created by gavin on 19/1/11.
 */
import axios from "../../utils/axios";

// 获取信息
export function versionGetInfo(query) {
    return axios({
        url: "/version/getInfo",
        method: "get",
        params: query
    });
}
// 保存更改
export function versionEdit(data) {
    return axios({
        url: "/version/edit",
        method: "post",
        data: data
    });
}
